webpackJsonp([1],{

/***/ "/SF/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BPgM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BYZe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ck7V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//


/* harmony default export */ var App = ({
    data: function data() {
        return {
            toUrl: "/applyfor"
        };
    },
    created: function created() {
        document.body.removeChild(document.getElementById("Loading"));
        this.loading = true;
        this.toUrl = window.location.href.indexOf("applyfor") !== -1 ? "/applyfor" : "/reimburse";

        if (window.location.search.match(/id=([^&]+)/)) {
            localStorage.setItem("FlowId", window.location.search.match(/id=([^&]+)/)[1]);
        } else {
            localStorage.removeItem('FlowId');
        }
        // 即使通信
        if (window.location.search.match(/platform=([^&]+)/)) {
            sessionStorage.setItem("platform", window.location.search.match(/platform=([^&]+)/)[1]);
        } else {
            sessionStorage.removeItem('platform');
        }
        // 卡片feishucard pc+手机  审批feishuapprove pc+手机
        if (window.location.search.match(/doType=([^&]+)/)) {
            sessionStorage.setItem("doType", window.location.search.match(/doType=([^&]+)/)[1]);
        } else {
            sessionStorage.removeItem('doType');
        }
        // deviceType  移动是mobile   pc是  pc
        if (window.location.search.match(/deviceType=([^&]+)/)) {
            sessionStorage.setItem("deviceType", window.location.search.match(/deviceType=([^&]+)/)[1]);
        } else {
            sessionStorage.removeItem('deviceType');
        }
        if (window.location.search.match(/type=([^&]+)/)) {
            sessionStorage.setItem("markType", window.location.search.match(/type=([^&]+)/)[1]);
        } else {
            sessionStorage.removeItem('markType');
        }
        if (window.location.search.match(/zhbg_tk=([^&]+)/)) {
            // pc端获取token
            localStorage.setItem("rx_token", window.location.search.match(/zhbg_tk=([^&]+)/)[1]);
        } else {
            localStorage.removeItem('rx_token');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-104c0f36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-link',{attrs:{"to":_vm.toUrl}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("Qst5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./src/config.js
var develop = {
    apiBase: 'https://rxapp.services.chailv8.net'
    // apiBase: 'http://localhost:8080',
};

var cnpc = {
    apiBase: 'https://rxapp.services.cnpc.chailv8.com'
};

var newDevelop = {
    apiBase: 'https://rxapi.kld.kdtmc.net'
};

var newCnpc = {
    apiBase: 'https://rxapi.kld.kdtmc.com'
};

function getConfig() {
    switch (window.location.hostname) {
        case 'rxweb.services.chailv8.net':
            return develop;
        case 'rxweb.services.cnpc.chailv8.com':
            return cnpc;
        case 'rxweb.kld.kdtmc.net':
            return newDevelop;
        case 'rxweb.kld.kdtmc.com':
            return newCnpc;
        default:
            return develop;
    }
}

var current = getConfig();

var getApiURL = function getApiURL(path) {
    return current.apiBase + (path === undefined ? '/' : path);
};


// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/businessApplication.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var businessApplication = ({
    data: function data() {
        return {
            id: this.$route.query.id,
            List: [],
            ActionType: [],
            TrafficPlan: [],
            Travellers: [],
            HotelPlan: [],
            AuditHistory: [],
            fileRepertories: [],
            LongApplyFor: "1",
            tabId: "",
            activeIndex: "1",
            activeIndex2: "1",
            centerDialogVisible: false,
            CustomFieldInstances: [],
            form: {
                suggest: ""
            },
            message: "",
            fullscreenLoading: false,
            isDisplay: false,
            Destinations: [],
            applyForm: {},
            submitter: {}
        };
    },

    methods: {
        convertState: function convertState(state) {
            switch (state) {
                case -1:
                default:
                    return "未提交";
                case 0:
                    return "审批中";
                case 1:
                    return "已通过";
                case 2:
                    return "被驳回";
            }
        },
        getTokenCode: function getTokenCode() {
            var fs_token = localStorage.fs_token;
            var rxToken = localStorage.rx_token;
            var markType = sessionStorage.markType;
            var doType = sessionStorage.doType;
            var deviceType = sessionStorage.deviceType; //判断他是pc端还是移动端

            var token_type = void 0;
            var rx_token = void 0;

            if (markType) {
                if (deviceType === 'mobile') {
                    token_type = 'FEI_SHU_TOKEN'; // 审批
                    rx_token = fs_token;
                } else if (deviceType === 'pc') {
                    token_type = 'UNIFIED_OFFICE_TODO'; // pc
                    rx_token = rxToken;
                }
                if (!doType) {
                    token_type = 'UNIFIED_OFFICE_TODO'; //即使通信 统一办公PC端
                    rx_token = rxToken;
                }
            } else {
                if (rxToken) {
                    token_type = 'RUI_XIN';
                    rx_token = rxToken;
                } else {
                    //作废
                    token_type = 'FEI_SHU_TOKEN';
                    rx_token = fs_token;
                }
            }

            return { token_type: token_type, rx_token: rx_token };
        },
        getToken: function getToken() {
            var fs_token = localStorage.fs_token;
            var rxToken = localStorage.rx_token;
            var markType = sessionStorage.markType;
            var doType = sessionStorage.doType;
            var deviceType = sessionStorage.deviceType; //判断他是pc端还是移动端

            var token_type = void 0;
            var rx_token = void 0;

            if (markType) {
                if (deviceType === 'mobile') {
                    token_type = 'FEI_SHU_CODE'; // 审批
                    rx_token = fs_token;
                } else if (deviceType === 'pc') {
                    token_type = 'UNIFIED_OFFICE_TODO'; // pc
                    rx_token = rxToken;
                }
                if (!doType) {
                    token_type = 'UNIFIED_OFFICE_TODO'; //即使通信 统一办公PC端
                    rx_token = rxToken;
                }
            } else {
                if (rxToken) {
                    token_type = 'RUI_XIN';
                    rx_token = rxToken;
                } else {
                    //作废
                    token_type = 'FEI_SHU_CODE';
                    rx_token = fs_token;
                }
            }

            return { token_type: token_type, rx_token: rx_token };
        },
        getFeishu: function getFeishu() {
            // 获取 URL 中的参数
            var urlParams = new URLSearchParams(window.location.search);
            var code = urlParams.get('code');

            if (code) {
                // 存储授权码
                localStorage.setItem("fs_token", code);
                // 处理授权码
                this.getDetail();
                // 删除 code 参数并保留其他参数
                urlParams.delete('code');
                var newQueryString = urlParams.toString();
                var newUrl = "" + window.location.origin + window.location.pathname + (newQueryString ? '?' + newQueryString : '');
                // 更新浏览器地址栏中的 URL，但不刷新页面
                window.history.replaceState({}, document.title, newUrl);
            } else {
                // 构建授权 URL
                var redirectUri = encodeURIComponent(window.location.href);
                var appId = 'cli_a6d43c60a2f8d366';
                var state = 'STATE';
                var authUrl = "https://open.fklzl.cnpc.com.cn/open-apis/authen/v1/authorize?app_id=" + appId + "&redirect_uri=" + redirectUri + "&state=" + state;
                // 重定向到授权页面
                window.location.href = authUrl;
            }
        },
        setMarkType: function setMarkType() {
            var markType = sessionStorage.markType;
            var platform = sessionStorage.platform;
            var deviceType = sessionStorage.deviceType;

            if (markType) {
                if (deviceType === 'mobile') {
                    //审批
                    this.$loading({
                        $loading: true,
                        text: '保存成功'
                    });
                    setTimeout(function () {
                        window.close();
                    }, 1500);
                } else if (deviceType === 'pc') {
                    this.$loading({
                        $loading: true,
                        text: '保存成功'
                    });
                    setTimeout(function () {
                        window.close();
                    }, 1500);
                }
                if (platform) {
                    //即时通信
                    this.$loading({
                        $loading: true,
                        text: '保存成功'
                    });
                    setTimeout(function () {
                        wx.closeWindow();
                    }, 1500);
                } else {
                    //pc
                    this.$loading({
                        $loading: true,
                        text: '保存成功'
                    });
                    setTimeout(function () {
                        window.close();
                    }, 1500);
                }
            } else {
                this.$loading({
                    $loading: true,
                    text: '同步待办处理中'
                });
                setTimeout(function () {
                    window.location.replace("https://app.cnpc.com.cn:8443/rxshared/private_todo/");
                }, 3000);
            }
        },

        // 驳回
        onReject: function onReject() {
            var _this = this;

            var rootUrl = getApiURL("");
            var FlowId = localStorage.FlowId;
            var suggest = this.form.suggest;

            var ret = this.getTokenCode();

            var params = extends_default()({}, ret, {
                p_code: "RFCAIWU",
                encrypted: "1",
                data: {
                    ComType: "ApplyReturn",
                    FlowID: FlowId,
                    Suggestion: suggest
                }
            });

            this.$http({
                method: "post",
                dataType: "jsonp",
                url: rootUrl + "/process?req_data=" + encodeURIComponent(stringify_default()(params))
            }).then(function (res) {
                _this.setMarkType();
            });
        },

        //取消
        onCancel: function onCancel() {
            document.getElementById("tab-0").click();
        },
        open2: function open2() {
            var _this2 = this;

            this.$confirm("确认通过此业务申请?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "info"
            }).then(function () {
                var rootUrl = getApiURL("");
                var FlowId = localStorage.FlowId;
                var suggest = _this2.form.suggest;

                var ret = _this2.getTokenCode();

                var params = extends_default()({}, ret, {
                    p_code: "RFCAIWU",
                    encrypted: "1",
                    data: {
                        ComType: "SubmitApply",
                        FlowID: FlowId,
                        Suggestion: suggest
                    }
                });

                _this2.$http({
                    method: "post",
                    dataType: "jsonp",
                    url: rootUrl + "/process?req_data=" + encodeURIComponent(stringify_default()(params))
                }).then(function (res) {
                    _this2.setMarkType();
                });
            }).catch(function () {});
        },

        // 通过
        onApprove: function onApprove() {
            document.getElementById("tab-1").click();
        },
        open3: function open3() {
            var _this3 = this;

            this.$confirm("驳回时意见不能为空", "提示", {
                confirmButtonText: "确定",
                type: "info"
            }).then(function () {
                document.getElementById("tab-1").click();
                _this3.isDisplay = true;
            }).catch(function () {});
        },
        handleClick: function handleClick(tab, event) {
            var $this = this;
            $this.isDisplay = false;
            $this.tabId = event.target.id;
        },
        getDetail: function getDetail() {
            var $this = this;
            var rootUrl = getApiURL("");
            var FlowId = localStorage.FlowId;
            $this.fullscreenLoading = true;

            var ret = this.getToken();

            var params = extends_default()({}, ret, {
                p_code: "RFCAIWU",
                encrypted: "1",
                data: {
                    ComType: "GetApplyDetails",
                    FlowID: FlowId,
                    FlowTypeID: 2
                } });

            this.$http({
                method: "post",
                dataType: "jsonp",
                url: rootUrl + "/process?req_data=" + encodeURIComponent(stringify_default()(params))
            }).then(function (res) {
                $this.fullscreenLoading = false;

                var Data = res.data.data;

                if (Data.token) {
                    localStorage.setItem("fs_token", Data.token);
                } else {
                    localStorage.removeItem('fs_token');
                }
                var obj = {},
                    list = new Array(obj);
                obj["ActionType"] = Data.ActionType;
                obj["Amount"] = Data.Amount;
                obj["ApplyCode"] = Data.ApplyCode;
                obj["ApplyEndDate"] = Data.ApplyEndDate;
                obj["ApplyStartDate"] = Data.ApplyStartDate;
                obj["International"] = Data.International;
                obj["Remark"] = Data.Remark;
                obj["UserName"] = Data.UserName;
                $this.List = list;
                $this.CustomFieldInstances = res.data.data.CustomFieldInstances; //自定义表单  数据
                $this.TrafficPlan = res.data.data.TrafficPlan;
                $this.Travellers = res.data.data.Travellers;
                $this.HotelPlan = res.data.data.HotelPlan;
                $this.fileRepertories = res.data.data.fileRepertories;
                $this.LongApplyFor = res.data.data.LongApplyFor == true ? "1" : "2";
                $this.AuditHistory = res.data.data.AuditHistory;
                $this.Destinations = res.data.data.destinations;
                $this.applyForm = res.data.data.applyForm;
                $this.submitter = res.data.data.submitter;
            }).catch(function (res) {
                $this.fullscreenLoading = false;
                $this.$router.push({ path: "*" });
            });
        }
    },
    mounted: function mounted() {
        var rxToken = localStorage.rx_token;
        var markType = sessionStorage.markType;
        var doType = sessionStorage.doType;
        var deviceType = sessionStorage.deviceType; //判断他是pc端还是移动端

        if (markType) {
            if (deviceType === 'mobile') {
                this.getFeishu();
            } else if (deviceType === 'pc') {
                this.getDetail();
            }
            if (!doType) {
                this.getDetail();
            }
        } else {
            if (rxToken) {
                this.getDetail();
            } else {
                //代办应用 已废弃
                this.getFeishu();
            }
        }
    },

    components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-720f05f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/businessApplication.vue
var businessApplication_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}]},[_c('div',{staticClass:"topBar"}),_vm._v(" "),_c('div',{staticClass:"cardTop"},[(_vm.applyForm && _vm.submitter)?_c('div',{staticClass:"bodyCard"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"titleCard"},[_c('div',{staticClass:"reimburs"},[_vm._v("出差申请")]),_vm._v(" "),_c('div',{staticClass:"claimStatus"},[_vm._v(_vm._s(_vm.convertState(_vm.applyForm.approvalState)))])]),_vm._v(" "),_c('div',{staticClass:"LRstylebox titleCard"},[_c('span',{staticStyle:{"color":"black"}},[_vm._v(_vm._s(_vm.submitter.staffUserName))]),_vm._v(" "),_c('span',[_vm._v("提交于"+_vm._s(_vm.applyForm.createdAt))])])])]):_vm._e()]),_vm._v(" "),_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":_vm.handleClick}},[_c('el-tab-pane',{attrs:{"label":"基本信息"}},[_c('div',{staticClass:"bodyCard"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"line"},[_vm._v("基本信息")]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.List && _vm.List.length > 0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.List),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出差申请单号")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.ApplyCode))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出差开始时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.ApplyStartDate))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出差结束时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.ApplyEndDate))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出差目的")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.ActionType))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.ActionType !== '因私出行'),expression:"item.ActionType !== '因私出行'"}]},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("是否长差")]),_vm._v(" "),_c('span',[_c('el-radio',{attrs:{"label":"1","disabled":""},model:{value:(_vm.LongApplyFor),callback:function ($$v) {_vm.LongApplyFor=$$v},expression:"LongApplyFor"}},[_vm._v("是")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2","disabled":""},model:{value:(_vm.LongApplyFor),callback:function ($$v) {_vm.LongApplyFor=$$v},expression:"LongApplyFor"}},[_vm._v("否")])],1)]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("预算")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Amount))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("国际出差")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.International==1?"是":"否"))])])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("备注")]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":item.Remark,"placement":"top-end"}},[_c('span',{staticClass:"remark-text"},[_vm._v(_vm._s(item.Remark))])])],1)])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"titleLine"},[_vm._v("\n        出行人\n        "),_c('span',[_vm._v("（"+_vm._s(_vm.Travellers ? _vm.Travellers.length : 0)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.Travellers && _vm.Travellers.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.Travellers),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("姓名")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Name))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("手机号")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Phone))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("邮箱")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Email))])])])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"titleLine"},[_vm._v("\n        出差城市\n        "),_c('span',[_vm._v("（"+_vm._s(_vm.Destinations ? _vm.Destinations.length : 0)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.Destinations && _vm.Destinations.length>0)?_c('div',{staticClass:" bg-purple",staticStyle:{"display":"flex","flex-wrap":"wrap"}},_vm._l((_vm.Destinations),function(item){return _c('div',{key:item.index,staticClass:"LRstyle",staticStyle:{"width":"50%"}},[_vm._v("\n                "+_vm._s(item.name)+"\n              ")])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"titleLine"},[_vm._v("\n        交通计划\n        "),_c('span',[_vm._v("（"+_vm._s(_vm.TrafficPlan ? _vm.TrafficPlan.length : 0)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.TrafficPlan && _vm.TrafficPlan.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.TrafficPlan),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("交通工具")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.TrafficType))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出发地")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.StartCity))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("目的地")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.EndCity))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.StartDate))])])])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"titleLine"},[_vm._v("\n        自定义表单\n        "),_c('span')]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.CustomFieldInstances && _vm.CustomFieldInstances.length > 0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.CustomFieldInstances),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v(_vm._s(item.fieldName))]),_vm._v(" "),(item.fieldValues &&item.fieldValues.length > 0)?_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":item.fieldValues.join(),"placement":"top-end"}},_vm._l((item.fieldValues),function(it,idx){return _c('span',{key:idx,staticClass:"remark-text"},[_vm._v(_vm._s(it+" "))])})):_vm._e()],1)])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"titleLine"},[_vm._v("\n        住宿计划\n        "),_c('span',[_vm._v("（"+_vm._s(_vm.HotelPlan ? _vm.HotelPlan.length : 0)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.HotelPlan && _vm.HotelPlan.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.HotelPlan),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("城市")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.City))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("入住时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.StartDate))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("离开时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.EndDate))])])])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"titleLine"},[_vm._v("\n        附件信息\n        "),_c('span',[_vm._v("（"+_vm._s(_vm.fileRepertories ? _vm.fileRepertories.length : 0)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.fileRepertories && _vm.fileRepertories.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.fileRepertories),function(item){return _c('span',{key:item.index},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.url),expression:"item.url"}],staticClass:"fileRepertories",attrs:{"src":"","alt":"附件信息"}})])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"提示","visible":_vm.centerDialogVisible,"width":"30%","center":""},on:{"update:visible":function($event){_vm.centerDialogVisible=$event}}},[_c('span',[_vm._v("请填写审批意见！")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.centerDialogVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.centerDialogVisible = false}}},[_vm._v("确 定")])],1)])],1)])]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"审批意见"},on:{"click":function($event){_vm.click()}}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"80px"}},[_c('div',{staticClass:"bodyCard"},[_c('div',{staticClass:"card"},[_c('el-form-item',{staticClass:"label-suggest",attrs:{"label":"填写审批意见","prop":"suggest"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.suggest),callback:function ($$v) {_vm.$set(_vm.form, "suggest", $$v)},expression:"form.suggest"}})],1)],1)]),_vm._v(" "),(!_vm.isDisplay)?_c('el-form-item',[_c('el-button',{staticClass:"goback",attrs:{"type":"text"}},[_c('div',{staticClass:"fail-button",on:{"click":_vm.onCancel}},[_c('div',[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"success-button",on:{"click":_vm.open2}},[_c('img',{attrs:{"src":"@/assets/tongyi.png","alt":""}}),_vm._v(" "),_c('div',[_vm._v("同意")])])])],1):_vm._e(),_vm._v(" "),(_vm.isDisplay)?_c('el-form-item',{staticClass:"btn-suggest goback"},[_c('div',{staticClass:"fail-button",on:{"click":_vm.onCancel}},[_c('div',[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"success-button",on:{"click":_vm.onReject}},[_c('img',{attrs:{"src":"@/assets/tongyi.png","alt":""}}),_vm._v(" "),_c('div',[_vm._v("拒绝")])])]):_vm._e()],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"审批记录"}},[_c('div',{staticClass:"bodyCard"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"suggest-box info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('div',{staticClass:"block"},[(_vm.AuditHistory  && _vm.AuditHistory.length > 0)?_c('el-timeline',_vm._l((_vm.AuditHistory),function(activity,index){return _c('el-timeline-item',{key:index,attrs:{"timestamp":activity.CreateDate}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[(activity.UserName)?_c('span',{staticClass:"label"},[_vm._v("操作人：")]):_vm._e(),_c('span',[_vm._v(_vm._s(activity.UserName))])]),_vm._v(" "),(activity.Status)?_c('div',{staticClass:"row"},[_c('span',{staticClass:"label"},[_vm._v("状态：")]),_c('span',[_vm._v(_vm._s(activity.Status))])]):_vm._e(),_vm._v(" "),(activity.Suggestion)?_c('div',{staticClass:"row"},[_c('span',{staticClass:"label"},[_vm._v("备注：")]),_c('span',[_vm._v(_vm._s(activity.Suggestion))])]):_vm._e()])])})):_c('div',[_vm._v("暂无数据")])],1)])],1)])])])],1),_vm._v(" "),(_vm.tabId !== 'tab-1')?_c('el-button',{staticClass:"goback",attrs:{"type":"text"}},[_c('div',{staticClass:"fail-button",on:{"click":_vm.open3}},[_c('img',{attrs:{"src":"@/assets/jujue.png","alt":""}}),_vm._v(" "),_c('div',[_vm._v("拒绝")])]),_vm._v(" "),_c('div',{staticClass:"success-button",on:{"click":_vm.onApprove}},[_c('img',{attrs:{"src":"@/assets/tongyi.png","alt":""}}),_vm._v(" "),_c('div',[_vm._v("同意")])])]):_vm._e()],1)}
var businessApplication_staticRenderFns = []
var businessApplication_esExports = { render: businessApplication_render, staticRenderFns: businessApplication_staticRenderFns }
/* harmony default export */ var pages_businessApplication = (businessApplication_esExports);
// CONCATENATED MODULE: ./src/pages/businessApplication.vue
function businessApplication_injectStyle (ssrContext) {
  __webpack_require__("yW9x")
}
var businessApplication_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var businessApplication___vue_template_functional__ = false
/* styles */
var businessApplication___vue_styles__ = businessApplication_injectStyle
/* scopeId */
var businessApplication___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var businessApplication___vue_module_identifier__ = null
var businessApplication_Component = businessApplication_normalizeComponent(
  businessApplication,
  pages_businessApplication,
  businessApplication___vue_template_functional__,
  businessApplication___vue_styles__,
  businessApplication___vue_scopeId__,
  businessApplication___vue_module_identifier__
)

/* harmony default export */ var src_pages_businessApplication = (businessApplication_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/tripReimbursement.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tripReimbursement = ({
    data: function data() {
        return {
            id: this.$route.query.id,
            List: [],
            BasicInfo: [],
            TrafficFee: [],
            HotelFee: [],
            PaymentInfo: [],
            UserInfo: [],
            OtherFee: [],
            Allowance: [],
            AuditHistory: [],
            fileRepertories: [],
            LongApplyFor: "1",
            suggestion: "",
            tabId: "",
            activeIndex: "1",
            activeIndex2: "1",
            centerDialogVisible: false,
            isDisplay: false,
            message: "",
            fullscreenLoading: false,
            approvalOpinion: "已知悉存在超标账目",
            submitter: {},
            reimburse: {}
        };
    },

    methods: {
        convertState: function convertState(state) {
            switch (state) {
                case -1:
                default:
                    return "未提交";
                case 0:
                    return "审批中";
                case 1:
                    return "已通过";
                case 2:
                    return "被驳回";
            }
        },
        getTokenCode: function getTokenCode() {
            var fs_token = localStorage.fs_token;
            var rxToken = localStorage.rx_token;
            var markType = sessionStorage.markType;
            var doType = sessionStorage.doType;
            var deviceType = sessionStorage.deviceType; //判断他是pc端还是移动端

            var token_type = void 0;
            var rx_token = void 0;

            if (markType) {
                if (deviceType === 'mobile') {
                    token_type = 'FEI_SHU_TOKEN'; // 审批
                    rx_token = fs_token;
                } else if (deviceType === 'pc') {
                    token_type = 'UNIFIED_OFFICE_TODO';
                    rx_token = rxToken;
                }
                if (!doType) {
                    token_type = 'UNIFIED_OFFICE_TODO'; //即使通信 统一办公pc
                    rx_token = rxToken;
                }
            } else {
                if (rxToken) {
                    token_type = 'RUI_XIN';
                    rx_token = rxToken;
                } else {
                    //作废
                    token_type = 'FEI_SHU_TOKEN';
                    rx_token = fs_token;
                }
            }

            return { token_type: token_type, rx_token: rx_token };
        },
        getToken: function getToken() {
            var fs_token = localStorage.fs_token;
            var rxToken = localStorage.rx_token; //zhbg_tk
            var markType = sessionStorage.markType;
            var deviceType = sessionStorage.deviceType;
            var doType = sessionStorage.doType;

            var token_type = void 0;
            var rx_token = void 0;

            if (markType) {
                if (deviceType === 'mobile') {
                    token_type = 'FEI_SHU_CODE'; // 审批
                    rx_token = fs_token;
                } else if (deviceType === 'pc') {
                    token_type = 'UNIFIED_OFFICE_TODO'; // pc
                    rx_token = rxToken;
                }
                if (!doType) {
                    token_type = 'UNIFIED_OFFICE_TODO'; //即使通信 统一办公pc
                    rx_token = rxToken;
                }
            } else {
                if (rxToken) {
                    token_type = 'RUI_XIN';
                    rx_token = rxToken;
                } else {
                    //废弃
                    token_type = 'FEI_SHU_CODE';
                    rx_token = fs_token;
                }
            }

            return { token_type: token_type, rx_token: rx_token };
        },
        getFeishu: function getFeishu() {
            // 获取 URL 中的参数
            var urlParams = new URLSearchParams(window.location.search);
            var code = urlParams.get('code');

            if (code) {
                // 存储授权码
                localStorage.setItem("fs_token", code);
                // 处理授权码
                this.getDetail();
                // 删除 code 参数并保留其他参数
                urlParams.delete('code');
                var newQueryString = urlParams.toString();
                var newUrl = "" + window.location.origin + window.location.pathname + (newQueryString ? '?' + newQueryString : '');
                // 更新浏览器地址栏中的 URL，但不刷新页面
                window.history.replaceState({}, document.title, newUrl);
            } else {
                // 构建授权 URL
                var redirectUri = encodeURIComponent(window.location.href);
                var appId = 'cli_a6d43c60a2f8d366';
                var state = 'STATE';

                var authUrl = "https://open.fklzl.cnpc.com.cn/open-apis/authen/v1/authorize?app_id=" + appId + "&redirect_uri=" + redirectUri + "&state=" + state;
                // 重定向到授权页面
                window.location.href = authUrl;
            }
        },
        setMarkType: function setMarkType() {
            var markType = sessionStorage.markType;
            var platform = sessionStorage.platform;
            var deviceType = sessionStorage.deviceType;
            if (markType) {
                if (deviceType === 'mobile') {
                    //审批
                    this.$loading({
                        $loading: true,
                        text: '保存成功'
                    });
                    setTimeout(function () {
                        tt.closeWindow();
                    }, 1500);
                } else if (deviceType === 'pc') {
                    this.$loading({
                        $loading: true,
                        text: '保存成功'
                    });
                    setTimeout(function () {
                        window.close();
                    }, 1500);
                }
                if (platform) {
                    //即时通信
                    this.$loading({
                        $loading: true,
                        text: '保存成功'
                    });
                    setTimeout(function () {
                        wx.closeWindow();
                    }, 1500);
                } else {
                    //pc
                    this.$loading({
                        $loading: true,
                        text: '保存成功'
                    });
                    setTimeout(function () {
                        window.close();
                    }, 1500);
                }
            } else {
                this.$loading({
                    $loading: true,
                    text: '同步待办处理中'
                });
                setTimeout(function () {
                    window.location.replace("https://app.cnpc.com.cn:8443/rxshared/private_todo/");
                }, 3000);
            }
        },

        //驳回审批
        onReject: function onReject() {
            var _this = this;

            var rootUrl = getApiURL("");
            var FlowId = localStorage.FlowId;
            var suggest = this.suggestion;

            var ret = this.getTokenCode();

            var params = extends_default()({}, ret, {
                p_code: "RFCAIWU",
                encrypted: "1",
                data: {
                    ComType: "AuditReturn",
                    FlowID: FlowId,
                    Suggestion: suggest
                }
            });
            this.$http({
                method: "post",
                dataType: "jsonp",
                url: rootUrl + "/process?req_data=" + encodeURIComponent(stringify_default()(params))
            }).then(function (res) {
                _this.setMarkType();
            });
        },

        //退回审批
        onCancel: function onCancel() {
            document.getElementById("tab-0").click();
        },

        // 通过进审批意见
        onApprove: function onApprove() {
            document.getElementById("tab-1").click();
        },
        open2: function open2() {
            var _this2 = this;

            this.$confirm("确认通过此业务申请?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "info"
            }).then(function () {
                var rootUrl = getApiURL("");
                var FlowId = localStorage.FlowId;
                var suggest = _this2.TrafficFee && _this2.TrafficFee.find(function (it) {
                    return it.IsExceed;
                }) ? _this2.approvalOpinion : _this2.suggestion;
                var ret = _this2.getTokenCode();
                var params = extends_default()({}, ret, {
                    p_code: "RFCAIWU",
                    encrypted: "1",
                    data: {
                        ComType: "SubmitAudit",
                        FlowID: FlowId,
                        Suggestion: suggest
                    }
                });
                _this2.$http({
                    method: "post",
                    dataType: "jsonp",
                    url: rootUrl + "/process?req_data=" + encodeURIComponent(stringify_default()(params))
                }).then(function (res) {
                    _this2.setMarkType();
                });
            }).catch(function () {});
        },

        // 驳回
        open3: function open3() {
            var _this3 = this;

            this.$confirm("驳回时意见不能为空", "提示", {
                confirmButtonText: "确定",
                type: "info"
            }).then(function () {
                document.getElementById("tab-1").click();
                _this3.isDisplay = true;
            }).catch(function () {});
        },
        handleClick: function handleClick(tab, event) {
            var $this = this;
            $this.isDisplay = false;
            $this.tabId = event.target.id;
        },
        getDetail: function getDetail() {
            var $this = this;
            var rootUrl = getApiURL("");
            var FlowId = localStorage.FlowId;
            $this.fullscreenLoading = true;
            var ret = this.getToken();

            var params = extends_default()({}, ret, {
                p_code: "RFCAIWU",
                encrypted: "1",
                data: {
                    ComType: "GetDetailsOfFlow",
                    FlowID: FlowId,
                    FlowTypeID: 1
                }
            });
            this.$http({
                method: "post",
                dataType: "jsonp",
                url: rootUrl + "/process?req_data=" + encodeURIComponent(stringify_default()(params))
            }).then(function (res) {
                $this.fullscreenLoading = false;

                var Data = res.data.data;
                if (Data.token) {
                    localStorage.setItem("fs_token", Data.token);
                } else {
                    localStorage.removeItem('fs_token');
                }

                var obj = {},
                    list = new Array(obj);
                obj["AimName"] = Data.BasicInfo.AimName;
                obj["Content"] = Data.BasicInfo.Content;
                obj["PID"] = Data.BasicInfo.PID;
                obj["ProjectName"] = Data.BasicInfo.ProjectName;
                $this.BasicInfo = list;
                $this.PaymentInfo = res.data.data.PaymentInfo;
                $this.UserInfo = res.data.data.UserInfo;
                $this.OtherFee = res.data.data.OtherFee;
                $this.HotelFee = res.data.data.HotelFee;
                $this.Allowance = res.data.data.Allowance;
                $this.TrafficFee = res.data.data.TrafficFee;
                $this.AuditHistory = res.data.data.AuditHistory;
                $this.fileRepertories = res.data.data.fileRepertories;
                $this.LongApplyFor = res.data.data.LongApplyFor == true ? "1" : "2";
                $this.submitter = res.data.data.submitter;
                $this.reimburse = res.data.data.reimburse;
            }).catch(function (res) {
                $this.fullscreenLoading = false;
                $this.$router.push({ path: "*" });
            });
        }
    },
    mounted: function mounted() {
        var rxToken = localStorage.rx_token;
        var doType = sessionStorage.doType;
        var markType = sessionStorage.markType;
        var deviceType = sessionStorage.deviceType;

        if (markType) {
            if (deviceType === 'mobile') {
                //移动端
                this.getFeishu();
            } else if (deviceType === 'pc') {
                this.getDetail();
            }
            if (!doType) {
                //即使通信 统一办公pc端
                this.getDetail();
            }
        } else {
            if (rxToken) {
                this.getDetail();
            } else {
                //代办应用废弃
                this.getFeishu();
            }
        }
    },

    components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28d583b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/tripReimbursement.vue
var tripReimbursement_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}]},[_c('div',{staticClass:"topBar"}),_vm._v(" "),(_vm.reimburse && _vm.submitter)?_c('div',{staticClass:"cardTop"},[_c('div',{staticClass:"bodyCard"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"titleCard"},[_c('div',{staticClass:"reimburs"},[_vm._v("差旅报销")]),_vm._v(" "),_c('div',{staticClass:"claimStatus"},[_vm._v(_vm._s(_vm.convertState(_vm.reimburse.approvalState)))])]),_vm._v(" "),_c('div',{staticClass:"LRstylebox titleCard"},[_c('span',{staticStyle:{"color":"black"}},[_vm._v(_vm._s(_vm.submitter.staffUserName))]),_vm._v(" "),_c('span',[_vm._v("提交于"+_vm._s(_vm.reimburse.createdAt))])])])])]):_vm._e(),_vm._v(" "),_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":_vm.handleClick}},[_c('el-tab-pane',{attrs:{"type":"border-card","label":"基本信息"}},[_c('div',{staticClass:"bodyCard"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"line"},[_vm._v("基本信息")]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.BasicInfo && _vm.BasicInfo.length > 0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.BasicInfo),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出差目的")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.AimName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出差事由")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Content))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("成本对象编码")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.PID))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("成本对象")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.ProjectName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("是否长差")]),_vm._v(" "),_c('span',[_c('el-radio',{attrs:{"label":"1","disabled":""},model:{value:(_vm.LongApplyFor),callback:function ($$v) {_vm.LongApplyFor=$$v},expression:"LongApplyFor"}},[_vm._v("是")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2","disabled":""},model:{value:(_vm.LongApplyFor),callback:function ($$v) {_vm.LongApplyFor=$$v},expression:"LongApplyFor"}},[_vm._v("否")])],1)])])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"titleLine"},[_vm._v("\n          出差人员\n          "),_c('span',[_vm._v("（"+_vm._s(_vm.UserInfo ? _vm.UserInfo.length : 0)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.UserInfo && _vm.UserInfo.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.UserInfo),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("姓名")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.UserName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("类别")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.UserType))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("部门")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.DeptName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("工作基地")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.WorkPlace))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("电话")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Mobile))])])])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"titleLine"},[_vm._v("\n          城市间交通费\n          "),_c('span',[_vm._v("（"+_vm._s(_vm.TrafficFee ? _vm.TrafficFee.length : 0)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.TrafficFee && _vm.TrafficFee.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.TrafficFee),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("人员")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.UserName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("票据类型")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.TicketType))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出发地")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.StartCity))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("目的地")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.EndCity))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出发时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.StartDate))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("报销金额")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Sum))])])])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"titleLine"},[_vm._v("\n          住宿费用\n          "),_c('span',[_vm._v("（"+_vm._s(_vm.HotelFee ? _vm.HotelFee.length : 0)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.HotelFee && _vm.HotelFee.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.HotelFee),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("人员")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.UserName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("城市")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.City))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("酒店名称")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.HotelName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("入住时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.StartDate))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("离开时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.EndDate))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("金额")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Sum))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("标准金额")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.SumStandard))])])])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"titleLine"},[_vm._v("\n          补助费用\n          "),_c('span',[_vm._v("（"+_vm._s(_vm.Allowance ? _vm.Allowance.length : 0)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.Allowance && _vm.Allowance.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.Allowance),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("人员")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.UserName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("开始日期")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.StartDate))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("结束日期")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.EndDate))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("补助天数")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.TripDays))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("金额（元）")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Sum))])])])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"titleLine"},[_vm._v("\n          其他费用\n          "),_c('span',[_vm._v("（"+_vm._s(_vm.OtherFee ? _vm.OtherFee.length : 0)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.OtherFee && _vm.OtherFee.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.OtherFee),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("人员")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.UserName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("报销类别")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.CostCodeName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("月份")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.CostMonthStub))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("备注")]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":item.Remark,"placement":"top"}},[_c('span',{staticClass:"remark-text"},[_vm._v(_vm._s(item.Remark))])])],1),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("核定金额（元）")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Sum))])])])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"titleLine"},[_vm._v("\n          支付信息\n          "),_c('span',[_vm._v("（"+_vm._s(_vm.PaymentInfo ? _vm.PaymentInfo.length : 0)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.PaymentInfo && _vm.PaymentInfo.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.PaymentInfo),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("人员")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.UserName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("收款账号")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.PayAccount))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("合计金额")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Amount))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("冲抵备用金")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.ReserveFundsAmount))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("冲抵公司卡")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.CompanyCardAmount))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("应支付金额")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.PayAmount))])])])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"titleLine"},[_vm._v("附件信息")]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.fileRepertories && _vm.fileRepertories.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.fileRepertories),function(item){return _c('span',{key:item.index},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.url),expression:"item.url"}],staticClass:"fileRepertories",attrs:{"src":"","alt":"附件信息"}})])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1)])]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"提示","visible":_vm.centerDialogVisible,"width":"30%","center":""},on:{"update:visible":function($event){_vm.centerDialogVisible=$event}}},[_c('span',[_vm._v("请填写审批意见！")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.centerDialogVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.centerDialogVisible = false}}},[_vm._v("确 定")])],1)])],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"审批意见"}},[_c('el-form',{ref:"form",attrs:{"label-width":"80px"}},[_c('div',{staticClass:"bodyCard"},[_c('div',{staticClass:"card"},[_c('el-form-item',{staticClass:"label-suggest",attrs:{"label":"填写审批意见"}},[(!_vm.isDisplay&& _vm.TrafficFee && _vm.TrafficFee.find(function (it){ return it.IsExceed; }))?_c('el-input',{staticClass:"indented-input",attrs:{"type":"textarea"},model:{value:(_vm.approvalOpinion),callback:function ($$v) {_vm.approvalOpinion=$$v},expression:"approvalOpinion"}}):_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.suggestion),callback:function ($$v) {_vm.suggestion=$$v},expression:"suggestion"}})],1)],1)]),_vm._v(" "),(!_vm.isDisplay)?_c('el-form-item',[_c('el-button',{staticClass:"goback",attrs:{"type":"text"}},[_c('div',{staticClass:"fail-button",on:{"click":_vm.onCancel}},[_c('div',[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"success-button",on:{"click":_vm.open2}},[_c('img',{attrs:{"src":"@/assets/tongyi.png","alt":""}}),_vm._v(" "),_c('div',[_vm._v("同意")])])])],1):_vm._e(),_vm._v(" "),(_vm.isDisplay)?_c('el-form-item',{staticClass:"goback"},[_c('div',{staticClass:"fail-button",on:{"click":_vm.onCancel}},[_c('div',[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"success-button",on:{"click":_vm.onReject}},[_c('img',{attrs:{"src":"@/assets/tongyi.png","alt":""}}),_vm._v(" "),_c('div',[_vm._v("拒绝")])])]):_vm._e()],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"审批记录"}},[_c('div',{staticClass:"bodyCard",staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"suggest-box info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('div',{staticClass:"block"},[(_vm.AuditHistory && _vm.AuditHistory.length > 0)?_c('el-timeline',_vm._l((_vm.AuditHistory),function(activity,index){return _c('el-timeline-item',{key:index,attrs:{"timestamp":activity.CreateDate}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[(activity.UserName)?_c('span',{staticClass:"label"},[_vm._v("操作人：")]):_vm._e(),_c('span',[_vm._v(_vm._s(activity.UserName))])]),_vm._v(" "),(activity.Status)?_c('div',{staticClass:"row"},[_c('span',{staticClass:"label"},[_vm._v("状态：")]),_c('span',[_vm._v(_vm._s(activity.Status))])]):_vm._e(),_vm._v(" "),(activity.Suggestion)?_c('div',{staticClass:"row"},[_c('span',{staticClass:"label"},[_vm._v("备注：")]),_c('span',[_vm._v(_vm._s(activity.Suggestion))])]):_vm._e()])])})):_c('div',[_vm._v("暂无数据")])],1)])],1)])])])],1),_vm._v(" "),(_vm.tabId !== 'tab-1')?_c('el-button',{staticClass:"goback",attrs:{"type":"text"}},[_c('div',{staticClass:"fail-button",on:{"click":_vm.open3}},[_c('img',{attrs:{"src":"@/assets/jujue.png","alt":""}}),_vm._v(" "),_c('div',[_vm._v("拒绝")])]),_vm._v(" "),_c('div',{staticClass:"success-button",on:{"click":_vm.onApprove}},[_c('img',{attrs:{"src":"@/assets/tongyi.png","alt":""}}),_vm._v(" "),_c('div',[_vm._v("同意")])])]):_vm._e()],1)}
var tripReimbursement_staticRenderFns = []
var tripReimbursement_esExports = { render: tripReimbursement_render, staticRenderFns: tripReimbursement_staticRenderFns }
/* harmony default export */ var pages_tripReimbursement = (tripReimbursement_esExports);
// CONCATENATED MODULE: ./src/pages/tripReimbursement.vue
function tripReimbursement_injectStyle (ssrContext) {
  __webpack_require__("Ck7V")
}
var tripReimbursement_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var tripReimbursement___vue_template_functional__ = false
/* styles */
var tripReimbursement___vue_styles__ = tripReimbursement_injectStyle
/* scopeId */
var tripReimbursement___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tripReimbursement___vue_module_identifier__ = null
var tripReimbursement_Component = tripReimbursement_normalizeComponent(
  tripReimbursement,
  pages_tripReimbursement,
  tripReimbursement___vue_template_functional__,
  tripReimbursement___vue_styles__,
  tripReimbursement___vue_scopeId__,
  tripReimbursement___vue_module_identifier__
)

/* harmony default export */ var src_pages_tripReimbursement = (tripReimbursement_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/basicInformation.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var basicInformation = ({
    data: function data() {
        return {
            id: this.$route.query.id,
            List: [],
            ActionType: [],
            TrafficPlan: [],
            Travellers: [],
            HotelPlan: [],
            AuditHistory: [],
            fileRepertories: [],
            LongApplyFor: "1",
            tabId: "",
            activeIndex: "1",
            activeIndex2: "1",
            centerDialogVisible: false,
            form: {
                suggest: ""
            },
            message: ""
        };
    },

    methods: {
        // 通过
        open: function open() {
            var _this = this;

            var email = localStorage.email;
            var suggest = '"' + this.form.suggest + '"',
                id = '"' + this.id + '"';
            var rootUrl = getApiURL("");
            this.$http({
                method: "post",
                dataType: "jsonp",
                url: rootUrl + '/process?req_data={"rx_token": "fasdfasdfasdfasdfasdfasdfasdfasdf","p_code": "RFCAIWU","user_id": ' + email + ',"encrypted": "1","data": {"ComType": "SubmitApply","FlowID": ' + id + ', "Suggestion": ' + suggest + "}}"
            }).then(function (res) {
                var Message = res.data.data.RetMessage;
            });
            this.$notify({
                title: "提示",
                message: "提交审批成功",
                position: "top-left"
            });
            setTimeout(function () {
                _this.$router.push({ path: "/" });
            }, 1000);
        },

        //退回
        openVn: function openVn() {
            var _this2 = this;

            var email = localStorage.email;
            var suggest = '"' + this.form.suggest + '"',
                id = '"' + this.id + '"';
            var rootUrl = getApiURL("");
            this.$http({
                method: "post",
                dataType: "jsonp",
                url: rootUrl + '/process?req_data={"rx_token": "fasdfasdfasdfasdfasdfasdfasdfasdf","p_code": "RFCAIWU","user_id": ' + email + ',"encrypted": "1","data": {"ComType": "ApplyReturn","FlowID": ' + id + ', "Suggestion": ' + suggest + "}}"
            }).then(function (res) {
                var Message = res.data.data.RetMessage;
            });
            this.$notify({
                title: "提示",
                message: "驳回审批成功",
                position: "top-left"
            });
            setTimeout(function () {
                _this2.$router.push({ path: "/" });
            }, 1000);
        },
        open2: function open2() {
            this.$confirm("请填写审批意见, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "info"
            }).then(function () {
                document.getElementById("tab-1").click();
            }).catch(function () {});
        },
        handleClick: function handleClick(tab, event) {
            var $this = this;
            $this.tabId = event.target.id;
        },
        getDetail: function getDetail() {
            var email = localStorage.email;
            var $this = this;
            var id = '"' + this.id + '"';

            var rootUrl = getApiURL("");
            this.$http({
                method: "post",
                dataType: "jsonp",
                url: rootUrl + '/process?req_data={"rx_token": "fasdfasdfasdfasdfasdfasdfasdfasdf","p_code": "RFCAIWU","user_id": ' + email + ',"encrypted": "1","data": {"ComType": "GetApplyDetails","FlowID": ' + id + ', "FlowTypeID": 2}}'
            }).then(function (res) {
                var Data = res.data.data;
                var obj = {},
                    list = new Array(obj);
                obj["ActionType"] = Data.ActionType;
                obj["Amount"] = Data.Amount;
                obj["ApplyCode"] = Data.ApplyCode;
                obj["ApplyEndDate"] = Data.ApplyEndDate;
                obj["ApplyStartDate"] = Data.ApplyStartDate;
                obj["International"] = Data.ActionType;
                obj["Remark"] = Data.Remark;
                obj["UserName"] = Data.UserName;
                $this.List = list;
                $this.TrafficPlan = res.data.data.TrafficPlan;
                $this.Travellers = res.data.data.Travellers;
                $this.HotelPlan = res.data.data.HotelPlan;
                $this.fileRepertories = res.data.data.fileRepertories;
                $this.LongApplyFor = res.data.data.LongApplyFor == true ? "1" : "2";
                $this.AuditHistory = res.data.data.AuditHistory;
            }).catch(function (res) {
                $this.$router.push({ path: "*" });
            });
        }
    },
    created: function created() {
        this.getDetail();
    },

    components: {
        // theButton
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45050a8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basicInformation.vue
var basicInformation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":_vm.handleClick}},[_c('el-tab-pane',{attrs:{"label":"基本信息"}},[_c('div',{staticClass:"line"},[_vm._v("基本信息")]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.List),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出差申请单号")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.ApplyCode))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出差开始时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.ApplyStartDate))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出差结束时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.ApplyEndDate))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出差目的")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.ActionType))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("是否长差")]),_vm._v(" "),_c('span',[_c('el-radio',{attrs:{"label":"1","disabled":""},model:{value:(_vm.LongApplyFor),callback:function ($$v) {_vm.LongApplyFor=$$v},expression:"LongApplyFor"}},[_vm._v("是")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2","disabled":""},model:{value:(_vm.LongApplyFor),callback:function ($$v) {_vm.LongApplyFor=$$v},expression:"LongApplyFor"}},[_vm._v("否")])],1)]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("预算")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Amount))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("国际出差")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.International))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("备注")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Remark))])])])}))]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"line"},[_vm._v("出行人"),_c('span',[_vm._v("（"+_vm._s(_vm.Travellers.length)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.Travellers),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("姓名")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Name))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("手机号")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Phone))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("邮箱")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Email))])])])}))]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"line"},[_vm._v("交通计划"),_c('span',[_vm._v("（"+_vm._s(_vm.TrafficPlan.length)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.TrafficPlan),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("交通工具")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.TrafficType))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出发地")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.StartCity))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("目的地")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.EndCity))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.StartDate))])])])}))]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"line"},[_vm._v("住宿计划"),_c('span',[_vm._v("（"+_vm._s(_vm.HotelPlan.length)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.HotelPlan.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.HotelPlan),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("城市")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.City))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("入住时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.StartDate))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("离开时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.EndDate))])])])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"line"},[_vm._v("附件信息"),_c('span',[_vm._v("（"+_vm._s(_vm.fileRepertories.length)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.fileRepertories.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.fileRepertories),function(item){return _c('span',{key:item.index},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.url),expression:"item.url"}],staticClass:"fileRepertories",attrs:{"src":"","alt":"附件信息"}})])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"line"},[_vm._v("历史审批记录")]),_vm._v(" "),_c('div',{staticClass:"suggest-box info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.AuditHistory}},[_c('el-table-column',{attrs:{"prop":"UserName","label":"操作人"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"FinishDate","label":"操作时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"Status","label":"状态"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"Suggestion","label":"备注"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"提示","visible":_vm.centerDialogVisible,"width":"30%","center":""},on:{"update:visible":function($event){_vm.centerDialogVisible=$event}}},[_c('span',[_vm._v("请填写审批意见！")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.centerDialogVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.centerDialogVisible = false}}},[_vm._v("确 定")])],1)])],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"审批意见"},on:{"click":function($event){_vm.click()}}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"80px"}},[_c('el-form-item',{staticClass:"label-suggest",attrs:{"label":"填写审批意见","prop":"suggest"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.suggest),callback:function ($$v) {_vm.$set(_vm.form, "suggest", $$v)},expression:"form.suggest"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"btn-suggest"},[_c('el-button',{attrs:{"type":"primary","plain":true},on:{"click":_vm.open}},[_vm._v("通过")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":true},on:{"click":_vm.openVn}},[_vm._v("退回")])],1)],1)],1)],1),_vm._v(" "),(_vm.tabId !== 'tab-1')?_c('el-button',{staticClass:"goback",attrs:{"type":"text"},on:{"click":_vm.open2}},[_c('el-button',{staticClass:"go",attrs:{"type":"info"}},[_vm._v("通过")]),_vm._v(" "),_c('el-button',{staticClass:"back",attrs:{"type":"info"}},[_vm._v("退回")])],1):_vm._e()],1)}
var basicInformation_staticRenderFns = []
var basicInformation_esExports = { render: basicInformation_render, staticRenderFns: basicInformation_staticRenderFns }
/* harmony default export */ var components_basicInformation = (basicInformation_esExports);
// CONCATENATED MODULE: ./src/components/basicInformation.vue
function basicInformation_injectStyle (ssrContext) {
  __webpack_require__("e6Uz")
}
var basicInformation_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var basicInformation___vue_template_functional__ = false
/* styles */
var basicInformation___vue_styles__ = basicInformation_injectStyle
/* scopeId */
var basicInformation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var basicInformation___vue_module_identifier__ = null
var basicInformation_Component = basicInformation_normalizeComponent(
  basicInformation,
  components_basicInformation,
  basicInformation___vue_template_functional__,
  basicInformation___vue_styles__,
  basicInformation___vue_scopeId__,
  basicInformation___vue_module_identifier__
)

/* harmony default export */ var src_components_basicInformation = (basicInformation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/basicInformation2.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var basicInformation2 = ({
    data: function data() {
        return {
            id: this.$route.query.id,
            List: [],
            BasicInfo: [],
            TrafficFee: [],
            HotelFee: [],
            PaymentInfo: [],
            UserInfo: [],
            OtherFee: [],
            Allowance: [],
            AuditHistory: [],
            fileRepertories: [],
            LongApplyFor: "1",
            suggestion: "",
            tabId: "",
            activeIndex: "1",
            activeIndex2: "1",
            centerDialogVisible: false,
            form: {
                suggest: ""
            },
            message: ""
        };
    },

    methods: {
        //通过审批
        open: function open() {
            var _this = this;

            var email = localStorage.email;
            var suggest = '"' + this.form.suggest + '"',
                id = '"' + this.id + '"';
            var rootUrl = getApiURL("");
            this.$http({
                method: "post",
                dataType: "jsonp",
                url: rootUrl + '/process?req_data={"rx_token": "fasdfasdfasdfasdfasdfasdfasdfasdf","p_code": "RFCAIWU","user_id": ' + email + ',"encrypted": "1","data": {"ComType": "SubmitAudit","FlowID": ' + id + ', "Suggestion": ' + suggest + "}}"
            }).then(function (res) {
                var Message = res.data.data.RetMessage;
            });
            this.$notify({
                title: "提示",
                message: "提交审批成功",
                position: "top-left"
            });
            setTimeout(function () {
                _this.$router.push({ path: "/tripReimbursement" });
                _this.activeIndex = "2";
            }, 2000);
        },

        //   退回审批
        openVn: function openVn() {
            var _this2 = this;

            var email = localStorage.email;
            var suggest = '"' + this.form.suggest + '"',
                id = '"' + this.id + '"';
            var rootUrl = getApiURL("");
            this.$http({
                method: "post",
                dataType: "jsonp",
                url: rootUrl + '/process?req_data={"rx_token": "fasdfasdfasdfasdfasdfasdfasdfasdf","p_code": "RFCAIWU","user_id": ' + email + ',"encrypted": "1","data": {"ComType": "AuditReturn","FlowID": ' + id + ', "Suggestion": ' + suggest + "}}"
            }).then(function (res) {
                var Message = res.data.data.RetMessage;
            });
            this.$notify({
                title: "提示",
                message: "驳回审批成功",
                position: "top-left"
            });
            setTimeout(function () {
                _this2.$router.push({ path: "/tripReimbursement" });
            }, 1000);
        },
        open2: function open2() {
            this.$confirm("请填写审批意见, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "info"
            }).then(function () {
                document.getElementById("tab-1").click();
            }).catch(function () {});
        },
        handleClick: function handleClick(tab, event) {
            var $this = this;
            $this.tabId = event.target.id;
        },
        getDetail: function getDetail() {
            var email = localStorage.email;
            var $this = this;
            var id = '"' + this.id + '"';
            var rootUrl = getApiURL("");
            this.$http({
                method: "post",
                dataType: "jsonp",
                url: rootUrl + '/process?req_data={"rx_token": "fasdfasdfasdfasdfasdfasdfasdfasdf","p_code": "RFCAIWU","user_id": ' + email + ',"encrypted": "1","data": {"ComType": "GetDetailsOfFlow","FlowID": ' + id + ', "FlowTypeID": 1}}'
            }).then(function (res) {
                var Data = res.data.data;
                var obj = {},
                    list = new Array(obj);
                obj["AimName"] = Data.BasicInfo.AimName;
                obj["Content"] = Data.BasicInfo.Content;
                obj["PID"] = Data.BasicInfo.PID;
                obj["ProjectName"] = Data.BasicInfo.ProjectName;
                $this.BasicInfo = list;
                $this.PaymentInfo = res.data.data.PaymentInfo;
                $this.UserInfo = res.data.data.UserInfo;
                $this.OtherFee = res.data.data.OtherFee;
                $this.HotelFee = res.data.data.HotelFee;
                $this.Allowance = res.data.data.Allowance;
                $this.TrafficFee = res.data.data.TrafficFee;
                $this.AuditHistory = res.data.data.AuditHistory;
                $this.fileRepertories = res.data.data.fileRepertories;
                $this.LongApplyFor = res.data.data.LongApplyFor == true ? "1" : "2";
            }).catch(function (res) {
                $this.$router.push({ path: "*" });
            });
        }
    },
    created: function created() {
        this.getDetail();
    },

    components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-075aa1ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basicInformation2.vue
var basicInformation2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":_vm.handleClick}},[_c('el-tab-pane',{attrs:{"label":"基本信息"}},[_c('div',{staticClass:"line"},[_vm._v("基本信息")]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.BasicInfo),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出差目的")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.AimName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出差事由")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Content))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("成本对象编码")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.PID))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("成本对象")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.ProjectName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("是否长差")]),_vm._v(" "),_c('span',[_c('el-radio',{attrs:{"label":"1","disabled":""},model:{value:(_vm.LongApplyFor),callback:function ($$v) {_vm.LongApplyFor=$$v},expression:"LongApplyFor"}},[_vm._v("是")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2","disabled":""},model:{value:(_vm.LongApplyFor),callback:function ($$v) {_vm.LongApplyFor=$$v},expression:"LongApplyFor"}},[_vm._v("否")])],1)])])}))]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"line"},[_vm._v("出差人员"),_c('span',[_vm._v("（"+_vm._s(_vm.UserInfo.length)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.UserInfo),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("姓名")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.UserName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("类别")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.UserType))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("部门")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.DeptName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("工作基地")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.WorkPlace))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("电话")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Mobile))])])])}))]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"line"},[_vm._v("城市间交通费"),_c('span',[_vm._v("（"+_vm._s(_vm.TrafficFee.length)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.TrafficFee),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("人员")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.UserName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("票据类型")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.TicketType))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出发地")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.StartCity))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("目的地")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.EndCity))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("出发时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.StartDate))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("报销金额")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Sum))])])])}))]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"line"},[_vm._v("住宿费用"),_c('span',[_vm._v("（"+_vm._s(_vm.HotelFee.length)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.HotelFee.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.HotelFee),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("人员")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.UserName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("城市")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.City))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("酒店名称")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.HotelName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("入住时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.StartDate))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("离开时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.EndDate))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("金额")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Sum))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("标准金额")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.SumStandard))])])])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"line"},[_vm._v("补助费用"),_c('span',[_vm._v("（"+_vm._s(_vm.Allowance.length)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.Allowance.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.Allowance),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("人员")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.UserName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("开始日期")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.StartDate))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("结束日期")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.EndDate))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("补助天数")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.TripDays))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("金额（元）")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Sum))])])])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"line"},[_vm._v("其他费用"),_c('span',[_vm._v("（"+_vm._s(_vm.OtherFee.length)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.OtherFee.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.OtherFee),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("人员")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.UserName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("报销类别")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.CostCodeName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("月份")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.CostMonthStub))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("备注")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Remark))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("核定金额（元）")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Sum))])])])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"line"},[_vm._v("支付信息"),_c('span',[_vm._v("（"+_vm._s(_vm.PaymentInfo.length)+"）")])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.PaymentInfo.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.PaymentInfo),function(item){return _c('ul',{key:item.index},[_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("人员")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.UserName))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("收款账号")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.PayAccount))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("合计金额")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Amount))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("冲抵备用金")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.ReserveFundsAmount))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("冲抵公司卡")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.CompanyCardAmount))])]),_vm._v(" "),_c('li',{staticClass:"LRstyle"},[_c('span',[_vm._v("应支付金额")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.PayAmount))])])])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"line"},[_vm._v("附件信息")]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[(_vm.fileRepertories.length>0)?_c('div',{staticClass:"grid-content bg-purple"},_vm._l((_vm.fileRepertories),function(item){return _c('span',{key:item.index},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.url),expression:"item.url"}],staticClass:"fileRepertories",attrs:{"src":"","alt":"附件信息"}})])})):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"line"},[_vm._v("历史审批记录")]),_vm._v(" "),_c('div',{staticClass:"suggest-box info-box"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.AuditHistory}},[_c('el-table-column',{attrs:{"prop":"UserName","label":"操作人"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"FinishDate","label":"操作时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"Status","label":"状态"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"Suggestion","label":"备注"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"提示","visible":_vm.centerDialogVisible,"width":"30%","center":""},on:{"update:visible":function($event){_vm.centerDialogVisible=$event}}},[_c('span',[_vm._v("请填写审批意见！")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.centerDialogVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.centerDialogVisible = false}}},[_vm._v("确 定")])],1)])],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"审批意见"}},[_c('el-form',{ref:"form",attrs:{"label-width":"80px"}},[_c('el-form-item',{staticClass:"label-suggest",attrs:{"label":"填写审批意见"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.suggestion),callback:function ($$v) {_vm.suggestion=$$v},expression:"suggestion"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"btn-suggest"},[_c('el-button',{attrs:{"type":"primary","plain":true},on:{"click":_vm.open}},[_vm._v("通过")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":true},on:{"click":_vm.openVn}},[_vm._v("退回")])],1)],1)],1)],1),_vm._v(" "),(_vm.tabId !== 'tab-1')?_c('el-button',{staticClass:"goback",attrs:{"type":"text"},on:{"click":_vm.open2}},[_c('el-button',{staticClass:"go",attrs:{"type":"info"}},[_vm._v("通过")]),_vm._v(" "),_c('el-button',{staticClass:"back",attrs:{"type":"info"}},[_vm._v("退回")])],1):_vm._e()],1)}
var basicInformation2_staticRenderFns = []
var basicInformation2_esExports = { render: basicInformation2_render, staticRenderFns: basicInformation2_staticRenderFns }
/* harmony default export */ var components_basicInformation2 = (basicInformation2_esExports);
// CONCATENATED MODULE: ./src/components/basicInformation2.vue
function basicInformation2_injectStyle (ssrContext) {
  __webpack_require__("BPgM")
}
var basicInformation2_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var basicInformation2___vue_template_functional__ = false
/* styles */
var basicInformation2___vue_styles__ = basicInformation2_injectStyle
/* scopeId */
var basicInformation2___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var basicInformation2___vue_module_identifier__ = null
var basicInformation2_Component = basicInformation2_normalizeComponent(
  basicInformation2,
  components_basicInformation2,
  basicInformation2___vue_template_functional__,
  basicInformation2___vue_styles__,
  basicInformation2___vue_scopeId__,
  basicInformation2___vue_module_identifier__
)

/* harmony default export */ var src_components_basicInformation2 = (basicInformation2_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/approvalOpinion.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import theButton from './theButton'
// import nav1 from './nav1'
/* harmony default export */ var approvalOpinion = ({
    data: function data() {
        return {};
    },

    components: {
        // theButton,
        // nav1
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-113a3b22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/approvalOpinion.vue
var approvalOpinion_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav1'),_vm._v(" "),_c('div',[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.list}},[_c('el-table-column',{attrs:{"prop":"FlowName","label":"审批意见如下"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('theButton')],1)}
var approvalOpinion_staticRenderFns = []
var approvalOpinion_esExports = { render: approvalOpinion_render, staticRenderFns: approvalOpinion_staticRenderFns }
/* harmony default export */ var components_approvalOpinion = (approvalOpinion_esExports);
// CONCATENATED MODULE: ./src/components/approvalOpinion.vue
function approvalOpinion_injectStyle (ssrContext) {
  __webpack_require__("v7mv")
}
var approvalOpinion_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var approvalOpinion___vue_template_functional__ = false
/* styles */
var approvalOpinion___vue_styles__ = approvalOpinion_injectStyle
/* scopeId */
var approvalOpinion___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var approvalOpinion___vue_module_identifier__ = null
var approvalOpinion_Component = approvalOpinion_normalizeComponent(
  approvalOpinion,
  components_approvalOpinion,
  approvalOpinion___vue_template_functional__,
  approvalOpinion___vue_styles__,
  approvalOpinion___vue_scopeId__,
  approvalOpinion___vue_module_identifier__
)

/* harmony default export */ var src_components_approvalOpinion = (approvalOpinion_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/approvalOpinion2.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import theButton from './theButton'
// import nav2 from './nav2'
/* harmony default export */ var approvalOpinion2 = ({
    data: function data() {
        return {
            list: []
        };
    },

    components: {
        //   theButton,
        //   nav2
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edafd6ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/approvalOpinion2.vue
var approvalOpinion2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav2'),_vm._v(" "),_c('div',[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.list}},[_c('el-table-column',{attrs:{"prop":"FlowName","label":"审批意见如下"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('theButton')],1)}
var approvalOpinion2_staticRenderFns = []
var approvalOpinion2_esExports = { render: approvalOpinion2_render, staticRenderFns: approvalOpinion2_staticRenderFns }
/* harmony default export */ var components_approvalOpinion2 = (approvalOpinion2_esExports);
// CONCATENATED MODULE: ./src/components/approvalOpinion2.vue
function approvalOpinion2_injectStyle (ssrContext) {
  __webpack_require__("S3FX")
}
var approvalOpinion2_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var approvalOpinion2___vue_template_functional__ = false
/* styles */
var approvalOpinion2___vue_styles__ = approvalOpinion2_injectStyle
/* scopeId */
var approvalOpinion2___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var approvalOpinion2___vue_module_identifier__ = null
var approvalOpinion2_Component = approvalOpinion2_normalizeComponent(
  approvalOpinion2,
  components_approvalOpinion2,
  approvalOpinion2___vue_template_functional__,
  approvalOpinion2___vue_styles__,
  approvalOpinion2___vue_scopeId__,
  approvalOpinion2___vue_module_identifier__
)

/* harmony default export */ var src_components_approvalOpinion2 = (approvalOpinion2_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/historyApprove.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import theButton from './theButton'
// import nav2 from './nav2'
/* harmony default export */ var historyApprove = ({
    data: function data() {
        return {
            list: []
        };
    },

    methods: {},
    created: function created() {},

    components: {
        //   theButton,
        //   nav2
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-761d970c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/historyApprove.vue
var historyApprove_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav2'),_vm._v(" "),_c('div',[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple"})]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.list}},[_c('el-table-column',{attrs:{"prop":"FlowName","label":"董建杰于处理中，具体意见如下"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":0,"md":0,"lg":0,"xl":0}},[_c('div',{staticClass:"grid-content bg-purple-light"})])],1)],1),_vm._v(" "),_c('theButton')],1)}
var historyApprove_staticRenderFns = []
var historyApprove_esExports = { render: historyApprove_render, staticRenderFns: historyApprove_staticRenderFns }
/* harmony default export */ var components_historyApprove = (historyApprove_esExports);
// CONCATENATED MODULE: ./src/components/historyApprove.vue
function historyApprove_injectStyle (ssrContext) {
  __webpack_require__("yZs4")
}
var historyApprove_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var historyApprove___vue_template_functional__ = false
/* styles */
var historyApprove___vue_styles__ = historyApprove_injectStyle
/* scopeId */
var historyApprove___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var historyApprove___vue_module_identifier__ = null
var historyApprove_Component = historyApprove_normalizeComponent(
  historyApprove,
  components_historyApprove,
  historyApprove___vue_template_functional__,
  historyApprove___vue_styles__,
  historyApprove___vue_scopeId__,
  historyApprove___vue_module_identifier__
)

/* harmony default export */ var src_components_historyApprove = (historyApprove_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/404.vue
//
//
//
//
//
//

/* harmony default export */ var _04 = ({
    data: function data() {
        return {};
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65257428","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/404.vue
var _04_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var _04_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":__webpack_require__("kvT1")}}),_vm._v(" "),_c('h1',[_vm._v("抱歉，页面好像去火星了~")])])}]
var _04_esExports = { render: _04_render, staticRenderFns: _04_staticRenderFns }
/* harmony default export */ var pages_404 = (_04_esExports);
// CONCATENATED MODULE: ./src/pages/404.vue
function _04_injectStyle (ssrContext) {
  __webpack_require__("/SF/")
}
var _04_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var _04___vue_template_functional__ = false
/* styles */
var _04___vue_styles__ = _04_injectStyle
/* scopeId */
var _04___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var _04___vue_module_identifier__ = null
var _04_Component = _04_normalizeComponent(
  _04,
  pages_404,
  _04___vue_template_functional__,
  _04___vue_styles__,
  _04___vue_scopeId__,
  _04___vue_module_identifier__
)

/* harmony default export */ var src_pages_404 = (_04_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/nav.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var nav = ({
    data: function data() {
        return {
            input: "",
            iptValue: "",
            list: [],
            sss: this.$route.name
        };
    },
    created: function created() {
        // console.log(this.input);
    },
    mounted: function mounted() {
        // console.log(this.input);
    },

    methods: {
        handleSelect: function handleSelect(key, keyPath) {
            // console.log(key, keyPath);
        },
        clickMe: function clickMe() {
            // console.log(this.input);
            // localStorage.clear();
            this.iptValue = localStorage.value;
            localStorage.setItem("value", this.input);
            // console.log(localStorage);
            window.location.reload();
        },
        enter: function enter() {
            if (event.keyCode == 13) {
                this.iptValue = localStorage.value;
                localStorage.setItem("value", this.input);
                // console.log(localStorage);
                window.location.reload();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d8658a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
var nav_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-menu',{staticClass:"el-menu-demo",attrs:{"default-active":_vm.sss,"mode":"horizontal","background-color":"#545c64","text-color":"#fff","active-text-color":"#ffd04b"},on:{"select":_vm.handleSelect}},[_c('router-link',{attrs:{"to":"/"}},[_c('el-menu-item',{attrs:{"index":"1"}},[_vm._v("出差申请")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/tripReimbursement"}},[_c('el-menu-item',{attrs:{"index":"2"}},[_vm._v("差旅报销")])],1)],1)],1)}
var nav_staticRenderFns = []
var nav_esExports = { render: nav_render, staticRenderFns: nav_staticRenderFns }
/* harmony default export */ var components_nav = (nav_esExports);
// CONCATENATED MODULE: ./src/components/nav.vue
function nav_injectStyle (ssrContext) {
  __webpack_require__("BYZe")
}
var nav_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var nav___vue_template_functional__ = false
/* styles */
var nav___vue_styles__ = nav_injectStyle
/* scopeId */
var nav___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var nav___vue_module_identifier__ = null
var nav_Component = nav_normalizeComponent(
  nav,
  components_nav,
  nav___vue_template_functional__,
  nav___vue_styles__,
  nav___vue_scopeId__,
  nav___vue_module_identifier__
)

/* harmony default export */ var src_components_nav = (nav_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js












vue_esm["default"].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
    mode: 'history',
    routes: [{
        path: '*',
        name: 'notfound',
        component: src_pages_404
    }, {
        path: '/applyfor',
        name: '1',
        component: src_pages_businessApplication
    }, {
        path: '/reimburse',
        name: '2',
        component: src_pages_tripReimbursement
    }, {
        path: '/basicInformation',
        name: 'basicInformation',
        component: src_components_basicInformation
    }, {
        path: '/basicInformation2',
        name: 'basicInformation2',
        component: src_components_basicInformation2
    }, {
        path: '/approvalOpinion',
        name: 'approvalOpinion',
        component: src_components_approvalOpinion
    }, {
        path: '/approvalOpinion2',
        name: 'approvalOpinion2',
        component: src_components_approvalOpinion2
    }, {
        path: '/historyApprove',
        name: 'historyApprove',
        component: src_components_historyApprove
    }, {
        path: '/nav',
        name: 'nav',
        component: src_components_nav
    }]
});

router.beforeEach(function (to, from, next) {
    if (to.name === '1') {
        window.document.title = '出差申请';
    } else if (to.name === "2") {
        window.document.title = '差旅报销';
    }
    next();
});
/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-paginate/dist/vue-paginate.js
var vue_paginate = __webpack_require__("/OX2");
var vue_paginate_default = /*#__PURE__*/__webpack_require__.n(vue_paginate);

// EXTERNAL MODULE: ./node_modules/vue-lazyload/vue-lazyload.js
var vue_lazyload = __webpack_require__("cTzj");
var vue_lazyload_default = /*#__PURE__*/__webpack_require__.n(vue_lazyload);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/index.css
var theme_chalk = __webpack_require__("tvR6");
var theme_chalk_default = /*#__PURE__*/__webpack_require__.n(theme_chalk);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











vue_esm["default"].use(vue_paginate_default.a);
vue_esm["default"].use(vue_lazyload_default.a, {
    preLoad: 1,
    attempt: 1
});
vue_esm["default"].use(element_ui_common_default.a);
vue_esm["default"].use(vuex_esm["a" /* default */]);

vue_esm["default"].prototype.getApiURL = {
    getApiURL: getApiURL
};
axios_default.a.defaults.withCredentials = true; // 全局配置
vue_esm["default"].prototype.$http = axios_default.a;

vue_esm["default"].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["default"]({
    el: '#app',
    router: src_router,
    template: '<App/>',
    components: {
        App: src_App
    },
    data: {
        langs: ['PHP', 'JavaScript', 'HTML', 'CSS', 'Ruby', 'Python']
    }
});

/***/ }),

/***/ "Qst5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S3FX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e6Uz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kvT1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404.aff8a3e.jpg";

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v7mv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yW9x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yZs4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d191b0e11716b9568ccb.js